import React, { useEffect, useState } from "react";
import ContentLoader from "react-content-loader";

const BASE_SCREEN_WIDTH = 1436;
const BASE_MAIN_CONTENT_WIDTH = 980;

export const MainSkeleton = ({ locals }) => {
  const webAppTheme = locals.activeUser.webAppTheme || "dark";
  const backgroundColor = webAppTheme === "dark" ? "#363C43" : "#F1F3F6";
  const foregroundColor = webAppTheme === "dark" ? "#40464D" : "#E0E4EA";
  const [chartSize, setChartSize] = useState({ width: 900, height: 182 });

  useEffect(() => {
    if (window) {
      const windowWidth = window.innerWidth;
      const chartWidth =
        (windowWidth * BASE_MAIN_CONTENT_WIDTH) / BASE_SCREEN_WIDTH;
      setChartSize({ ...chartSize, width: chartWidth });
    }
  }, []);

  return (
    <ContentLoader
      width={"100%"}
      height={chartSize.height}
      viewBox={`0 0 ${chartSize.width} ${chartSize.height}`}
      backgroundColor={backgroundColor}
      foregroundColor={foregroundColor}
      speed={1}
      title="Loading metrics..."
      className="mobile-hidden"
    >
      <rect x="0" y="0" rx="3" ry="3" width="25%" height="22" />
      <rect
        x={chartSize.width * 0.3 + 16}
        y="0"
        rx="3"
        ry="3"
        width="60%"
        height="22"
      />
      <rect
        x={chartSize.width * 0.9 + 32}
        y="0"
        rx="3"
        ry="3"
        width="5%"
        height="22"
      />
      <rect x="0" y="38" rx="3" ry="3" width="27%" height="22" />
      <rect
        x={chartSize.width * 0.3 + 16}
        y="38"
        rx="3"
        ry="3"
        width="55%"
        height="22"
      />
      <rect
        x={chartSize.width * 0.9 + 32}
        y="38"
        rx="3"
        ry="3"
        width="5%"
        height="22"
      />
      <rect x="0" y="76" rx="3" ry="3" width="15%" height="22" />
      <rect
        x={chartSize.width * 0.3 + 16}
        y="76"
        rx="3"
        ry="3"
        width="20%"
        height="22"
      />
      <rect
        x={chartSize.width * 0.9 + 32}
        y="76"
        rx="3"
        ry="3"
        width="5%"
        height="22"
      />
      <rect x="0" y="114" rx="3" ry="3" width="20%" height="22" />
      <rect
        x={chartSize.width * 0.3 + 16}
        y="114"
        rx="3"
        ry="3"
        width="40%"
        height="22"
      />
      <rect
        x={chartSize.width * 0.9 + 32}
        y="114"
        rx="3"
        ry="3"
        width="5%"
        height="22"
      />
      <rect x="0" y="152" rx="3" ry="3" width="30%" height="22" />
      <rect
        x={chartSize.width * 0.3 + 16}
        y="152"
        rx="3"
        ry="3"
        width="45%"
        height="22"
      />
      <rect
        x={chartSize.width * 0.9 + 32}
        y="152"
        rx="3"
        ry="3"
        width="5%"
        height="22"
      />
    </ContentLoader>
  );
};
